var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Bar',{attrs:{"id":"my-bar-chart-id","options":_vm.chartOptions,"chartData":_vm.chartData}})
}
var staticRenderFns = []

export { render, staticRenderFns }